import { render } from "./Membership.vue?vue&type=template&id=670bda1c&scoped=true&ts=true"
import script from "./Membership.vue?vue&type=script&lang=ts"
export * from "./Membership.vue?vue&type=script&lang=ts"

import "./Membership.vue?vue&type=style&index=0&id=670bda1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670bda1c"]])

export default __exports__